import { useBrandContext } from "../../../pages/Brand/BrandContext";
import { useElementContext } from "../../../contexts";

export interface BrandRangeListProps {
  rangeTilesSettings: "showOnlyDirectChild" | "showHierarchy";
  customStyleClasses?: string;
}

const BrandRangeList = ({ rangeTilesSettings, customStyleClasses }: BrandRangeListProps) => {
  const { ProductModule } = useElementContext();
  const { rangeList } = useBrandContext();
  if (!rangeList) return null;

  return (
    <ProductModule.CoreComponents.ProductTypeList
      {...rangeList}
      customStyleClasses={customStyleClasses}
      showOnlyDirectChild={rangeTilesSettings === "showOnlyDirectChild"}
    />
  );
};

export default BrandRangeList;
